const serviceData = [
  {
    id: 1,
    title: "Car Sales",
    icon: "ri-map-pin-2-line",
    desc: "Browse our available stock and get assistance choosing the right vehicle for your needs and budget.",
  },

  {
    id: 2,
    title: "UK Imports",
    icon: "ri-community-line",
    desc: "We source quality vehicles from the UK and guide you through the selection and import process.",
  },

  {
    id: 3,
    title: "South Africa Imports",
    icon: "ri-roadster-line",
    desc: "Looking for a specific car from South Africa? Send us your requirements and we will help you source it.",
  },

  {
    id: 4,
    title: "Custom Orders",
    icon: "ri-timer-flash-line",
    desc: "Order the model you want and choose your preferred color and key specifications.",
  },

  {
    id: 5,
    title: "Vehicle Sourcing Support",
    icon: "ri-map-pin-line",
    desc: "We provide guidance from enquiry to delivery, including recommendations and updates.",
  },

  {
    id: 6,
    title: "Customer Care",
    icon: "ri-flight-takeoff-line",
    desc: "Contact us anytime during office hours for availability, pricing, and import enquiries.",
  },
];

export default serviceData;
